export const Bills = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Outer rectangle - stroke only, no fill */}
            <rect
                x="3.5"
                y="3.5"
                width="17"
                height="17"
                rx="2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            {/* Text lines - these will be filled */}
            <rect x="7" y="7" width="10" height="1.5" rx="0.5" fill="currentColor" />
            <rect x="7" y="11" width="10" height="1.5" rx="0.5" fill="currentColor" />
            <rect x="7" y="15" width="5" height="1.5" rx="0.5" fill="currentColor" />
        </svg>
    );
};
